import React from "react";

interface IHeaderWidgetProps {
  header: string;
  para: string;
  icon: string;
}

export default function HeaderWidget(props: IHeaderWidgetProps): JSX.Element {
  return (
    <div className="header-widget">
      <div className="header-icon">
        <i className={props.icon} style={{color:"#750606"}}></i>
      </div>
      <div className="header-content">
        <h3>{props.header}</h3>
        <p>{props.para}</p>
      </div>
    </div>
  );
}
